/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Apr 11 2024
 **/

import styled from "@emotion/styled";

import { Icon, Row } from "@/frameworks/designStuff/components";

export const FileBoxWrapper = styled(Row.li)<{ hoverBackground?: keyof Colors; focus: boolean }>`
	width: 100%;
	padding: 6px 16px;
	border-radius: 16px;
	cursor: pointer;
	background-color: ${({ theme, focus }) => focus && theme.colors.accent_10_100};
	&:hover {
		background-color: ${({ hoverBackground, theme }) =>
			hoverBackground ? theme.colors[hoverBackground] : theme.colors.secondary_80_8};
	}
`;

export const MyFileArrowIcon = styled(Icon)<{ open: boolean }>`
	transform: ${({ open }) => open && "rotate(180deg)"};
`;
